import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=0e2d0eec&ts=true"
import script from "./ForgotPasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./ForgotPasswordForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__